// ----------------------------
// Created by Bulletproof Games
//            2017
//  www.bulletproofgames.co.uk
// ----------------------------
//
// Dublin Up Skip Wins Button

DUskipWinsButton = {};

DUskipWinsButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addSkipWinPlatformEnabledFlag(button);

  button.canEnable = function () {
    let playingAnims = winlineAnimationController.isAnimating;
    return (
      movieSymbolAnimatorDU.allowSkip && playingAnims && !this._flags.modal.active && this._flags.skipWinPlatformEnabled
    );
  };

  button.canShow = function () {
    let playingAnims = winlineAnimationController.isAnimating;
    return (
      movieSymbolAnimatorDU.allowSkip && playingAnims && !this._flags.modal.active && this._flags.skipWinPlatformEnabled
    );
  };

  button.onPressedCallback = function () {
    resourceManager.getController('inputOverlord').disableAll();
    winlineAnimationController.skipAnimations();
    gameController.skipWins();
    if (button.soundName !== '') {
      button.playSound();
    }
  };

  return button;
};

DUskipWinsButton.initialise = function (json, object) {
  object.soundName = json.soundName || '';
};
DUskipWinsButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'DUskipWinsButton',
  DUskipWinsButton.create,
  DUskipWinsButton.initialise,
  DUskipWinsButton.getFilesRequired
);
